import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpcenter-overview',
  templateUrl: './helpcenter-overview.component.html',
  styleUrls: ['./helpcenter-overview.component.css'],
  standalone: false,
})
export class HelpcenterOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
